import type { Estimation } from "@/interfaces/estimation.interface";

export const getMeasurementData = (id: string, measurementType: string, estimation?: Estimation): number => {
  const theData = estimation?.measurementData?.find((md) => md.id === id);
  if (theData) {
    return theData.measurement[measurementType] ?? 0;
  }
  return 0;
};
